import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function DeviceDropDown({setStatus,status}) {
  
  const handleChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  return (
    <Box sx={{ width:"81.5%" ,marginTop:"10px"}}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{status ? status :"Select Status"}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={status}
          label="Select Status"
          onChange={handleChange}
        >
          <MenuItem value={"All Status"}>All Status</MenuItem>
          <MenuItem value={"Pending"}>Pending</MenuItem>
          <MenuItem value={"Solved"}>Solved</MenuItem>
          <MenuItem value={"Unsolved"}>Unsolved</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
